'use strict';

var loadingIconCtrl = [function() {

}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {},
        controller: loadingIconCtrl,
        controllerAs: 'ctrl',
        templateUrl: 'loading-icon-directive/loadingIconDirective.html'
    };
};
